/**
 * Document status enum
 * Represents the various states a document can be in throughout its lifecycle
 */
export enum DOCUMENT_STATUS {
    CREATING = 'CREATING',
    REVIEW_CREATED = 'REVIEW_CREATED',
    EMAIL_PENDING = 'EMAIL_PENDING',
    READY_FOR_DOWNLOAD = 'READY_FOR_DOWNLOAD',
    DOWNLOADED = 'DOWNLOADED',
    UPLOADED_CHECKING = 'UPLOADED_CHECKING',
    ADJUSTMENT_NEEDED = 'ADJUSTMENT_NEEDED',
    REVISION_NEEDED = 'REVISION_NEEDED',
    PRESENTATION = 'PRESENTATION',
    AI_GENERATED = 'AI_GENERATED'
}

/**
 * Report type enum
 * Represents the different departments or categories for reports
 */
export enum REPORT_TYPE {
    AAC = 'AAC', // Airport Aviation Center
    AAF = 'AAF', // Airport Administration and Finance
    AIR = 'AIR', // Airport Information and Reporting
    AST = 'AST', // Airport Security Team
    CARGO = 'CARGO', // Cargo Operations
    COM = 'COM', // Communications
    HR = 'HR', // Human Resources
    IGS = 'IGS', // Information and Ground Services
    IT = 'IT', // Information Technology
    LEGAL = 'LEGAL', // Legal Department
    MCW = 'MCW', // Maintenance and Construction Works
    PCO = 'PCO', // Planning and Coordination
    PRC = 'PRC', // Procurement
    PUR = 'PUR', // Purchasing
    REM = 'REM', // Real Estate Management
    CAL = 'CAL' // Forecasting Calendar
}

/**
 * Document interface
 * Represents a document in the system with all its properties
 */
export interface IDocument {
    /** Unique identifier for the document */
    id: string;
    
    /** Timestamp when the document was created */
    created_at: string;
    
    /** Name of the document */
    name: string;
    
    /** Optional description of the document */
    description?: string;
    
    /** Timestamp when the document was last updated */
    updated_at?: string;

    /** Current status of the document */
    status: DOCUMENT_STATUS;
    
    /** User ID of the person who created the document */
    created_by: string;
    
    /** User ID of the person who last updated the document */
    updated_by?: string;
    
    /** ID of the associated forecast, if applicable */
    forecast_id?: string;
    
    /** ID of the associated file, if applicable */
    file_id?: string;
    
    /** ID of the associated email, if applicable */
    email_id?: string;
    
    /** Department or category of the report */
    report_type: REPORT_TYPE;
}
